/* eslint-disable no-shadow */
/* eslint-disable no-underscore-dangle */
import React, { useMemo, useState } from 'react';
import { Formik } from 'formik';
import ErrorBoundary from 'components/common/ErrorBoundary';
import { ADD_EDIT_CONSTANT } from 'utils/constants';
import {
  getStaffInitialValues,
  staffValidationSchema,
} from 'pages/Staff/constant';
import { toast } from 'react-toastify';
import { useMutation } from '@apollo/client';
import { UPDATE_STAFF, CREATE_STAFF } from 'pages/Staff/StaffgraphQL';
import AddEditStaffForm from './components/AddEditStaffForm';

const initialValues = {
  firstName: '',
  middleName: '',
  lastName: '',
  email: '',
  roles: [],
  permissions: [],
  callingCode: '',
  phone: '',
  assignedTraders: [],
  // aadhaarfrontpage: '',
  // aadhaarfrontpage1: '',
  // pancard: '',
};

const AddEditStaff = ({ drawerToggle, type, value, refetch }) => {
  const [user, setUser] = useState(initialValues);
  const [createUser] = useMutation(CREATE_STAFF);
  const [updateUser] = useMutation(UPDATE_STAFF);

  const previousUserSnapshot = useMemo(() => {
    if (type !== ADD_EDIT_CONSTANT.EDIT || !value) return null;
    return getStaffInitialValues(value);
  }, [type, value]);

  const buildUserInputDTO = (values) => {
    const {
      newPermissions,
      __typename,
      userExist,
      roles: roleObjects,
      permissions: existingPermissions,
      callingCode,
      assignedTraders,
      ...rest
    } = values || {};

    const roles = roleObjects?.map((r) => r.id);
    const selectedPermissions =
      newPermissions?.length > 0 ? newPermissions : existingPermissions;

    const userInputDTO = {
      ...rest,
      roles,
      callingCode: callingCode?.id,
      assignedTraders: assignedTraders?.map((r) => r.id),
    };

    if (selectedPermissions?.length) {
      userInputDTO.permissions = selectedPermissions.map(
        (permission) => permission.id,
      );
    }

    return userInputDTO;
  };

  const showUndoToast = (previousValues, message) => {
    if (!previousValues) {
      toast.success(message || 'Staff updated.');
      return;
    }

    toast.success(
      <div className="d-flex align-items-center gap-2">
        <span>{message || 'Staff updated.'}</span>
        <button
          type="button"
          className="btn btn-link p-0"
          onClick={async (event) => {
            event.stopPropagation();
            try {
              const undoInputDTO = buildUserInputDTO(previousValues);
              await updateUser({ variables: { userInputDTO: undoInputDTO } });
              await Promise.resolve(refetch?.());
              toast.info('Change reverted.');
            } catch (error) {
              const graphQLErrors = error?.graphQLErrors || [];
              if (graphQLErrors.length) {
                graphQLErrors.forEach(({ exception, message }) => {
                  toast.error(exception?.message || message);
                });
              } else {
                toast.error('Unable to revert changes.');
              }
            }
          }}
        >
          Undo
        </button>
      </div>,
      { autoClose: 5000 },
    );
  };

  const handleCreateError = (error) => {
    const graphQLErrors = error?.graphQLErrors || [];
    if (graphQLErrors.length) {
      graphQLErrors.forEach(() => {
        toast.error('Mobile Number is already registered');
      });
      return;
    }
    toast.error('Unable to create staff.');
  };

  const handleUpdateError = (error) => {
    const graphQLErrors = error?.graphQLErrors || [];
    if (graphQLErrors.length) {
      graphQLErrors.forEach(({ exception, message }) => {
        toast.error(exception?.message || message);
      });
      return;
    }
    toast.error('Unable to update staff.');
  };
  const updateFormIfUserExist = (user) => {
    setUser({ ...user, userExist: true });
  };
  const handleSubmit = async (values) => {
    try {
      const userInputDTO = buildUserInputDTO(values);

      if (type === ADD_EDIT_CONSTANT.EDIT || values?.userExist) {
        const response = await updateUser({ variables: { userInputDTO } });
        const message = response?.data?.updateUser;
        await Promise.resolve(refetch?.());
        drawerToggle('', ADD_EDIT_CONSTANT.ADD);
        showUndoToast(previousUserSnapshot, message);
      } else {
        delete userInputDTO?.id;
        const response = await createUser({ variables: { userInputDTO } });
        const message = response?.data?.createUser;
        await Promise.resolve(refetch?.());
        drawerToggle('', ADD_EDIT_CONSTANT.ADD);
        toast.success(message || 'Staff created.');
      }
    } catch (error) {
      if (type === ADD_EDIT_CONSTANT.EDIT || values?.userExist) {
        handleUpdateError(error);
      } else {
        handleCreateError(error);
      }
    }
  };

  return (
    <div>
      <ErrorBoundary>
        <Formik
          initialValues={
            type === ADD_EDIT_CONSTANT.EDIT
              ? getStaffInitialValues(value)
              : user
          }
          // enableReinitialize
          validationSchema={staffValidationSchema}
          onSubmit={handleSubmit}
          children={(props) => {
            return (
              <AddEditStaffForm
                type={type}
                updateFormIfUserExist={updateFormIfUserExist}
                {...props}
                drawerToggle={drawerToggle}
              />
            );
          }}
        />
      </ErrorBoundary>
    </div>
  );
};

export default AddEditStaff;
